import {FaCheckCircle, FaTimesCircle} from 'react-icons/fa';
import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";
import {useState} from "react";
import dynamicAPI from "../../../api/dynamicAPI";

const renderMethodBadge = (color, method, permission) => {
    return (
        permission.method === method && (
            <span className={`badge bg-${color} px-2`}>{permission.method}</span>
        )
    );
};

const ViewPermissions = ({
                             data,
                             editHandler,
                             deleteHandler,
                             fetchPermissionsAgain,
                         }) => {

    const [isSyncing, setIsSyncing] = useState(false);

    const handleSyncPermissions = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to reinitiate permissions?"
        );
        if (!confirmed) return;

        try {
            setIsSyncing(true);
            const result = await dynamicAPI('post', '/api/auth/reinitiate-permissions/');

            alert(
                `Permissions Sync Completed. ${result.createdCount} new permissions added.`
            );

            if (fetchPermissionsAgain) {
                fetchPermissionsAgain();
            }
        } catch (error) {
            console.error(error);
            alert(error.error || "Error syncing permissions.");
        } finally {
            setIsSyncing(false);
        }
    };


    return (
        <div className='table-responsive bg-light p-3 mt-2'>
            <button
                className="btn btn-warning btn-sm"
                onClick={handleSyncPermissions}
                disabled={isSyncing}
            >
                {isSyncing ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                ) : (
                    'Reinitiate Permissions'
                )}
            </button>
            <table className='table table-sm table-border'>
                <thead className='border-0'>
                <tr>
                    <th>Auth</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Method</th>
                    <th>Route</th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data &&
                    data.data.map((permission) => (
                        <tr key={permission._id}>
                            <td>
                                {permission.auth ? (
                                    <FaCheckCircle className='text-success'/>
                                ) : (
                                    <FaTimesCircle className='text-danger'/>
                                )}
                            </td>
                            <td>{permission.name}</td>
                            <td>{permission.description}</td>
                            <td>
                                {renderMethodBadge('primary', 'GET', permission)}
                                {renderMethodBadge('success', 'POST', permission)}
                                {renderMethodBadge('warning', 'PUT', permission)}
                                {renderMethodBadge('danger', 'DELETE', permission)}
                            </td>
                            <td>{permission.route}</td>

                            <td>
                                <div className='btn-group'>
                                    <button
                                        className='btn'
                                        onClick={() => editHandler(permission)}
                                        data-bs-toggle='modal'
                                        data-bs-target='#permissionModal'
                                    >
                                        <img src={EditItemIcon} alt="Edit"
                                             className="icon-img action-icons-img"/>
                                    </button>

                                    <button
                                        className='btn'
                                        onClick={() => deleteHandler(permission._id)}
                                    >
                                        <img src={DeleteItemIcon} alt="Delete"
                                             className="icon-img action-icons-img"/>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ViewPermissions;
